<template>
  <div class="goods_list">
    <goods-item v-for="it,i in item" :item="it" :key="i"></goods-item>
  </div>
</template>

<script>
export default {
  components: { },
  name: 'UniMailiangGoodsList',

  props: ['item'],

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
.goods_list{
  display: grid;
  grid-template-columns: repeat(2,1fr);
  grid-gap: .5rem;
  margin: 0 .5rem;
}
// @media screen and (min-width: 523px) {
//   .goods_list{
//     grid-template-columns: repeat(3,1fr) !important;
//     ::v-deep .goods_item{
//       width: 7.3rem;
//     }
//   }
// }
// @media screen and (width: 768px) {
//   .goods_list{
//     ::v-deep .goods_item{
//       width: 237px;
//     }
//     grid-template-columns: repeat(3,1fr) !important;
//   }
// }
</style>